<script>
	import { page } from '$app/stores'
	import { BLOG } from '$lib/routes'
	import { t } from '$lib/translations'

	export let category = {}
</script>

<nav
	class="breadcrumbs"
	aria-label="Breadcrumb"
	itemscope
	itemtype="https://schema.org/BreadcrumbList"
>
	<ol class="flex">
		<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
			<a href="/{BLOG}" itemprop="item">
				<span itemprop="name">{t('web.blog.title')}</span>
			</a>
			<meta itemprop="position" content="2" />
			<span class="mx-6 text-xs">&#10095;</span>
		</li>
		<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
			<a href="/{BLOG}/{category.slug || $page.data.article.categories[0].slug}" itemprop="item">
				<span itemprop="name">{category.title || $page.data.article.categories[0].title}</span>
			</a>
			<meta itemprop="position" content="3" />
		</li>
	</ol>
</nav>

<style>
	.breadcrumbs a {
		color: theme('colors.primary-500');
		font-size: theme('fontSize.xs');
		font-weight: theme('fontWeight.normal');
	}
</style>
